/**
 * @desc 缓存资源的校验级别
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(body: defs.auth.ResourceVerificationLevelDto, options?: any) {
  return updateResponse(
    http(URL + `/cache/resourceVerificationLevel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
